import useAppSelector from '../../hooks/useAppSelector';
import useAppDispatch from '../../hooks/useAppDispatch';
import { useCallback, useEffect } from 'preact/hooks';
import AssistantButton from './AssistantButton';
import AssistantBackdrop from './AssistantBackdrop';
import AssistantWindow from './AssistantWindow';

const Assistant = () => {
    const { mode } = useAppSelector(state => state.uiState);
    const dispatch = useAppDispatch();

    const closeWindow = useCallback(() => {
        dispatch.uiState.setMode('button');
    }, []);

    useEffect(() => {
        let onEscapeKeyDown: (event: KeyboardEvent) => void;
        if (mode === 'full') {
            document.body.classList.add('bri-scroll-disabled');
            onEscapeKeyDown = (event: KeyboardEvent) => {
                if (event.key === 'Escape') {
                    closeWindow();
                }
            };
            document.addEventListener('keydown', onEscapeKeyDown);
        } else {
            document.body.classList.remove('bri-scroll-disabled');
        }
        return () => {
            if (onEscapeKeyDown) {
                document.removeEventListener('keydown', onEscapeKeyDown);
            }
        };
    }, [mode, closeWindow]);

    if (mode === 'hidden') {
        return null;
    }

    return (
        <>
            <AssistantWindow />
            <AssistantButton />
            <AssistantBackdrop />
        </>
    );
};

export default Assistant;
